/**
 * @typedef FlowerHarvest
 * @type {object}
 * @property {number} id
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string} deleted_at
 * @property {number} confirmed_count
 * @property {number} min_count
 * @property {string} harvest_date
 * @property {number} price
 * @property {number} flower_id
 */

export default {
  namespaced: true,
  state: {
    /** @type {FlowerHarvest} */
    list: [],
    listArr: [],
    harvestWdays: []
  },
  mutations: {
    setData(state, payload) {
      state.list = payload;
      state.listArr = Object.keys(state.list)
        .map(Number)
        .sort((a, b) => a - b);
    },
    setHarvestWdays(state, payload) {
      state.harvestWdays = payload;
    }
  },
  actions: {
    async getFlowerHarvest({ commit, state, dispatch, rootState }, { date, flowerGenusId = null }) {
      const { flowers } = rootState;
      const flowersToLoad = [];
      const url = flowerGenusId ? `harvests?date=${date}&flower_genus_id=${flowerGenusId}` : `harvests?date=${date}`;
      const res = await this._vm.$http("get", url);
      if (res.status === 200) {
        let newData = state.list;
        newData = [];
        res.result.flower_harvests.forEach((value, index) => {
          const harvest = value;
          const harvest_date = harvest.harvest_date ? new Date(harvest.harvest_date) : null;
          const set_count = harvest.confirmed_count / harvest.min_count;

          newData[index] = {
            ...harvest,
            harvest_date,
            set_count
          };

          if (!flowers.list[harvest.flower_id]) {
            flowersToLoad.push(harvest.flower_id);
          }
        });

        commit("setData", newData);
        commit("setHarvestWdays", res.result.harvest_wdays);

        if (flowersToLoad.length) {
          await dispatch("flowers/getFlowers", flowersToLoad, { root: true });
        }
      }

      return true;
    },
    putFlowerHarvest({ commit, state }, data) {
      return new Promise(resolve => {
        this._vm.$http("put", "harvests", { flower_harvests: data }).then(res => {
          if (res.status === 200) {
            const newData = { ...state.list };

            Object.keys(data).forEach(id => {
              newData[id] = {
                ...newData[id],
                ...data[id]
              };
            });

            commit("setData", newData);
            resolve(true);
          }
        });
      });
    }
  },
  getters: {}
};
